import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { LoginResponse, SharedLoginRepository } from "../repositories/shared-login-repository";
import { Location } from "@angular/common";

export type UserState = {
	userId: string;
	name: string;
	username: string;
	credits: number;
	isAttorney: boolean;
	isLoggedIn: boolean;
	isPublicDefender: boolean;
	type: string;
	currentEmailOrBookingNumber: string;
	intercomHash: string;
}

export const UserStore = signalStore(
	{ providedIn: "root" },
	withState<UserState>({
		userId: null,
		name: null,
		username: null,
		credits: null,
		isAttorney: false,
		isPublicDefender: false,
		isLoggedIn: false,
		type: null,
		currentEmailOrBookingNumber: null,
		intercomHash: null
	}),
	withMethods((store, loginRepository = inject(SharedLoginRepository), router = inject(Router), location = inject(Location)) => ({
		fetchUser(): void {
			if (location.path().includes("login") || router.url.includes("login")
				|| location.path().includes("subscription") || router.url.includes("subscription")
				|| location.path().includes("resubscribe") || router.url.includes("resubscribe"))
			{
				return;
			}
			else
			{
				const jwt: string | null = localStorage.getItem("access_token");
				if (jwt)
				{
					loginRepository.getUser(jwt).subscribe({
						next: ((userLogin: LoginResponse) =>
						{
							if (userLogin.jwt)
							{
								patchState(store, {
									userId: userLogin.userId,
									name: userLogin.name,
									username: userLogin.username,
									credits: userLogin.credits,
									isLoggedIn: true,
									type: userLogin.type,
									currentEmailOrBookingNumber: userLogin.currentEmailOrBookingNumber,
									isAttorney: userLogin.isAttorney,
									isPublicDefender: userLogin.isPublicDefender,
									intercomHash: userLogin.intercomHash
								})
							}
							else
							{
								this.clearUser();
							}
						}),
						error: (err) =>
						{
							this.clearUser();
							this.logout();
						}
					});
				}
				else
				{
					this.logout();
				}
			}
		},
		login(response: LoginResponse): void {
			localStorage.setItem("access_token", response.jwt);
			patchState(store, {
				userId: response.userId,
				name: response.name,
				username: response.username,
				credits: response.credits,
				isLoggedIn: true,
				type: response.type,
				currentEmailOrBookingNumber: response.currentEmailOrBookingNumber,
				isAttorney: response.isAttorney,
				intercomHash: response.intercomHash
			})
		},
		logout(): void {
			if (localStorage.getItem("access_token")) {
				loginRepository.logout().subscribe({
					complete: () => {
						this.clearUser();
						router.navigate(["/login"]);
					}
				});
			}
			else {
				this.clearUser();
				router.navigate(["/login"]);
			}
		},
		clearUser(): void {
			localStorage.clear();
			patchState(store, {
				userId: null,
				name: null,
				username: null,
				credits: null,
				isLoggedIn: false,
				type: null,
				currentEmailOrBookingNumber: null,
				isAttorney: false,
				intercomHash: null
			})
		}
	}))
)
